import React, {Component} from 'react';

class CustomDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showItems: false,
      selectedItem: null,
    };
    this.dropDown = this.dropDown.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.validateActiveItem = this.validateActiveItem.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleKeyPressItem = this.handleKeyPressItem.bind(this);
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentWillReceiveProps(nextProps) {
    const inputQ = nextProps.deleteDropDown;
    const selectedQ = nextProps.selectedItem;
    const {deleteDropDown, selectedItem} = this.props;
    const newProps = deleteDropDown !== inputQ;
    const newSelect = (selectedItem && selectedItem.value) !== (selectedQ && selectedQ.value);

    if (newProps) {
      this.setState({selectedItem: null});
    }
    if (newSelect || selectedQ=='') {
      this.setState({selectedItem: selectedQ});
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
  }

  handleClick(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.handleClickOutside();
  }

  handleClickOutside() {
    this.setState({
      showItems: false,
    });
  }

  dropDown() {
    this.setState(prevState => ({
      showItems: !prevState.showItems,
    }));
  }

  selectItem(item) {
    this.setState({
      selectedItem: item,
      showItems: false,
    });
    this.props.optionClicked(item);
    // document.querySelectorAll(`.custom-dropdown[datavalue='${this.props.placeholder}'] .dropdown-selected-item`)[0].innerText = item.text
  }

  validateActiveItem(item) {    
    return this.state.selectedItem && this.state.selectedItem.value === item.value;
  }

  validateDefaultItem(item) {
    return (
      !this.state.selectedItem && this.props.selectedItem && this.props.selectedItem.value === item.value
    );
  }

  showRenderItem() {
    const selectedItem = this.state.selectedItem;
    const propsSelectedItem = this.props.selectedItem;

    let renderItem = '';
    if (selectedItem) {
      renderItem = selectedItem.text;
    } else if (!selectedItem && propsSelectedItem) {
      renderItem = propsSelectedItem.text;
    } else if (!propsSelectedItem || !selectedItem) {
      renderItem = null;
    }

    return renderItem;
  }

  handleKeyPress(event, cb) {
    if (event.key === 'Enter') {
      cb();
    }
  }

  handleKeyPressItem(event, item) {
    if (event.key === 'Enter') {
      this.selectItem(item);
    }
  }

  render() {
    return (
      <div className="custom-dropdown" ref={node => (this.node = node)} datavalue={this.props.placeholder}>
        <div
          className={`dropdown-container ${this.props.disabled ? 'disabled' : ''}   ${this.props.containerClassName} ${
            this.props.errorClass
            } ${this.state.showItems ? 'opened' : ''}`}
        >
          <div id={this.props.id || ""}
               tabIndex="1"
               className={`dropdown-selected-item ${this.props.disabled ? 'disabled' : ''}`}
               onKeyDown={event => this.handleKeyPress(event, this.dropDown)}
               onClick={this.dropDown}
          >
            {this.showRenderItem()}
          </div>
          <div
            tabIndex="1"
            className="dropdown-arrow"
            onKeyDown={event => this.handleKeyPress(event, this.dropDown)}
            onClick={this.dropDown}
          >
            {this.state.showItems ? (
              <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.10168 4.45184L4.74374 1.0975C4.8118 1.03456 4.90457 1 4.99999 1C5.09546 1 5.18825 1.03455 5.25632 1.09751L8.89838 4.45184C8.9658 4.51424 9 4.59543 9 4.67712C9 4.76307 8.96197 4.84838 8.88829 4.91144C8.7463 5.03279 8.52266 5.02908 8.38579 4.90246L4.99999 1.78529L1.61425 4.90247C1.47737 5.0291 1.25368 5.03279 1.1117 4.91139C0.966875 4.78755 0.96219 4.58089 1.10168 4.45184Z"
                  fill={this.props.color || '#EF3340'}
                />
                <path
                  d="M4.74374 1.0975L5.01536 1.39115L5.01473 1.39173L4.74374 1.0975ZM1.10168 4.45184L0.830026 4.15823L0.830695 4.15761L1.10168 4.45184ZM5.25632 1.09751L4.98533 1.39174L4.9847 1.39115L5.25632 1.09751ZM8.89838 4.45184L9.16936 4.15761L9.17009 4.15828L8.89838 4.45184ZM8.88829 4.91144L9.14839 5.21533L9.14816 5.21552L8.88829 4.91144ZM8.38579 4.90246L8.65672 4.60819L8.65743 4.60884L8.38579 4.90246ZM1.1117 4.91139L1.37165 4.60737L1.37165 4.60737L1.1117 4.91139ZM1.61425 4.90247L1.34262 4.60884L1.34332 4.6082L1.61425 4.90247ZM4.99999 1.78529L4.72906 1.49102L4.99999 1.24158L5.27092 1.49102L4.99999 1.78529ZM5.01473 1.39173L1.37266 4.74606L0.830695 4.15761L4.47276 0.803278L5.01473 1.39173ZM4.99999 1.4C5.0003 1.4 5.00123 1.39999 5.00316 1.39926C5.00513 1.39852 5.00968 1.3964 5.01536 1.39114L4.47213 0.803865C4.61887 0.668128 4.81056 0.6 4.99999 0.6L4.99999 1.4ZM4.9847 1.39115C4.99038 1.39641 4.99494 1.39853 4.99691 1.39927C4.99884 1.4 4.99975 1.4 4.99999 1.4L4.99999 0.6C5.18942 0.6 5.38114 0.668088 5.52793 0.80387L4.9847 1.39115ZM8.6274 4.74607L4.98533 1.39174L5.5273 0.803283L9.16936 4.15762L8.6274 4.74607ZM8.6 4.67712C8.6 4.70985 8.61451 4.73414 8.62668 4.7454L9.17009 4.15828C9.3171 4.29435 9.4 4.481 9.4 4.67712L8.6 4.67712ZM8.62819 4.60756C8.61608 4.61792 8.6 4.64231 8.6 4.67712L9.4 4.67712C9.4 4.88383 9.30786 5.07884 9.14839 5.21533L8.62819 4.60756ZM8.65743 4.60884C8.65231 4.6041 8.64772 4.60179 8.64519 4.60082C8.64395 4.60035 8.64312 4.60016 8.64272 4.60008C8.64232 4.6 8.64214 4.6 8.64211 4.6C8.64208 4.6 8.64195 4.6 8.64166 4.60004C8.64136 4.60009 8.64068 4.60022 8.63962 4.60058C8.63747 4.60132 8.63328 4.6032 8.62841 4.60737L9.14816 5.21552C8.85318 5.46763 8.40106 5.46151 8.11415 5.19608L8.65743 4.60884ZM1.37165 4.60737C1.36678 4.60321 1.36259 4.60132 1.36044 4.60058C1.35937 4.60022 1.35869 4.60009 1.35839 4.60004C1.3581 4.6 1.35797 4.6 1.35794 4.6C1.35791 4.6 1.35773 4.6 1.35733 4.60008C1.35693 4.60016 1.3561 4.60035 1.35486 4.60082C1.35234 4.60179 1.34775 4.6041 1.34262 4.60884L1.88588 5.1961C1.59894 5.46154 1.14674 5.46764 0.851747 5.2154L1.37165 4.60737ZM1.37333 4.74545C1.386 4.73372 1.40071 4.70825 1.39997 4.67474C1.39924 4.64141 1.38364 4.61762 1.37165 4.60737L0.851747 5.2154C0.526508 4.9373 0.51335 4.45122 0.830027 4.15823L1.37333 4.74545ZM5.27092 1.49102L8.65672 4.60819L8.11487 5.19674L4.72906 2.07957L5.27092 1.49102ZM1.34332 4.6082L4.72906 1.49102L5.27092 2.07956L1.88518 5.19675L1.34332 4.6082Z"
                  fill={this.props.color || '#EF3340'}
                />
              </svg>
            ) : (
              <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.10168 1.54816L4.74374 4.9025C4.8118 4.96544 4.90457 5 4.99999 5C5.09546 5 5.18825 4.96545 5.25632 4.90249L8.89838 1.54816C8.9658 1.48576 9 1.40457 9 1.32288C9 1.23693 8.96197 1.15162 8.88829 1.08856C8.7463 0.967212 8.52266 0.97092 8.38579 1.09754L4.99999 4.21471L1.61425 1.09753C1.47737 0.970904 1.25368 0.96721 1.1117 1.08861C0.966875 1.21245 0.96219 1.41911 1.10168 1.54816Z"
                  fill={this.props.color || '#EF3340'}
                />
                <path
                  d="M4.74374 4.9025L5.01536 4.60885L5.01473 4.60827L4.74374 4.9025ZM1.10168 1.54816L0.830026 1.84177L0.830695 1.84239L1.10168 1.54816ZM5.25632 4.90249L4.98533 4.60826L4.9847 4.60885L5.25632 4.90249ZM8.89838 1.54816L9.16936 1.84239L9.17009 1.84172L8.89838 1.54816ZM8.88829 1.08856L9.14839 0.784666L9.14816 0.784476L8.88829 1.08856ZM8.38579 1.09754L8.65672 1.39181L8.65743 1.39116L8.38579 1.09754ZM1.1117 1.08861L1.37165 1.39263L1.37165 1.39263L1.1117 1.08861ZM1.61425 1.09753L1.34262 1.39116L1.34332 1.3918L1.61425 1.09753ZM4.99999 4.21471L4.72906 4.50898L4.99999 4.75842L5.27092 4.50898L4.99999 4.21471ZM5.01473 4.60827L1.37266 1.25394L0.830695 1.84239L4.47276 5.19672L5.01473 4.60827ZM4.99999 4.6C5.0003 4.6 5.00123 4.60001 5.00316 4.60074C5.00513 4.60148 5.00968 4.6036 5.01536 4.60886L4.47213 5.19614C4.61887 5.33187 4.81056 5.4 4.99999 5.4L4.99999 4.6ZM4.9847 4.60885C4.99038 4.60359 4.99494 4.60147 4.99691 4.60073C4.99884 4.6 4.99975 4.6 4.99999 4.6L4.99999 5.4C5.18942 5.4 5.38114 5.33191 5.52793 5.19613L4.9847 4.60885ZM8.6274 1.25393L4.98533 4.60826L5.5273 5.19672L9.16936 1.84238L8.6274 1.25393ZM8.6 1.32288C8.6 1.29015 8.61451 1.26586 8.62668 1.2546L9.17009 1.84172C9.3171 1.70565 9.4 1.519 9.4 1.32288H8.6ZM8.62819 1.39244C8.61608 1.38208 8.6 1.35769 8.6 1.32288H9.4C9.4 1.11617 9.30786 0.921157 9.14839 0.784666L8.62819 1.39244ZM8.65743 1.39116C8.65231 1.3959 8.64772 1.39821 8.64519 1.39918C8.64395 1.39965 8.64312 1.39984 8.64272 1.39992C8.64232 1.4 8.64214 1.4 8.64211 1.4C8.64208 1.4 8.64195 1.4 8.64166 1.39996C8.64136 1.39991 8.64068 1.39978 8.63962 1.39942C8.63747 1.39868 8.63328 1.3968 8.62841 1.39263L9.14816 0.784476C8.85318 0.532374 8.40106 0.538486 8.11415 0.803918L8.65743 1.39116ZM1.37165 1.39263C1.36678 1.39679 1.36259 1.39868 1.36044 1.39942C1.35937 1.39978 1.35869 1.39991 1.35839 1.39996C1.3581 1.4 1.35797 1.4 1.35794 1.4C1.35791 1.4 1.35773 1.4 1.35733 1.39992C1.35693 1.39984 1.3561 1.39965 1.35486 1.39918C1.35234 1.39821 1.34775 1.3959 1.34262 1.39116L1.88588 0.803897C1.59894 0.538461 1.14674 0.532362 0.851747 0.784599L1.37165 1.39263ZM1.37333 1.25455C1.386 1.26628 1.40071 1.29175 1.39997 1.32526C1.39924 1.35859 1.38364 1.38238 1.37165 1.39263L0.851747 0.784599C0.526508 1.0627 0.51335 1.54878 0.830027 1.84177L1.37333 1.25455ZM5.27092 4.50898L8.65672 1.39181L8.11487 0.803261L4.72906 3.92043L5.27092 4.50898ZM1.34332 1.3918L4.72906 4.50898L5.27092 3.92044L1.88518 0.803254L1.34332 1.3918Z"
                  fill={this.props.color || '#EF3340'}
                />
              </svg>
            )}
          </div>
          <div
            className={`dropdown-placeholder ${
              this.state.selectedItem || this.props.selectedItem ? 'selected' : ''
              }`}
          >
            {this.props.placeholder}
          </div>
          <div className={`error-message ${this.state.errorClass == 'error' ? '' : 'hidden'}`}>
            {this.props.errorMessage}
          </div>
          <div
            style={{display: this.state.showItems ? 'block' : 'none'}}
            className={`dropdown-items ${this.props.overflowClass}`}
          >
            {this.props.items &&
            this.props.items.length &&
            this.props.items.map(item => (
              <div
                tabIndex="1"
                key={item.id}
                onKeyDown={event => this.handleKeyPressItem(event, item)}
                onClick={() => this.selectItem(item)}
                className={`dropdown-item ${
                  this.validateActiveItem(item) || this.validateDefaultItem(item)
                    ? 'selected'
                    : ''
                  }`}
              >
                {item.text}
                {/* {this.validateActiveItem(item) && (
                  <svg
                    className="check"
                    width="12"
                    height="9"
                    viewBox="0 0 12 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4.57143 8L1 4.63462L2 3.69231L4.57143 6.11539L10 1L11 1.94231L4.57143 8Z"
                      fill="#92D66F"
                      stroke="white"
                      strokeWidth="0.5"
                      strokeLinecap="square"
                      strokeLinejoin="round"
                    />
                  </svg>
                )} */}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default CustomDropDown;
